module.exports = __webpack_public_path__ + "static/media/arch.6e789c34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/arch.png
// module id = 67
// module chunks = 0